import Cookies from "js-cookie";
import store from "../../storage"
import Vue from "vue";
import api from "../api";
import bus from "../BusEmisor";
import sleep from "./sleep";
import events from "../../events";
import Status from "./status";

class Init {


	static loginStatus = false;

	static start() {

		Init.defineAuthStatus();
		Init.defineExtras();

	}

	static defineAuthStatus() {

		let token = Cookies.get("session_id");

		let infoUser = localStorage.getItem('infoUser');

		if (token && infoUser) {

			Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token

			Init.loginStatus = !!(token && infoUser);

			store.commit(
				"setLoginStatus",
				!!(token && infoUser)
			);

			store.commit(
				"setTokenAuth",
				token ? token : null
			);

			Init.getUserInfo().then(
				response => {
					let infoUserN = response.data.data;
					store.commit(
						"setInfoUser",
						infoUserN ? infoUserN : null
					);
					Init.startApp();
				},
				error => {
					if (error.response.status === 401 || error.response.status === "401") {

						Cookies.remove("session_id");

						let requireAuth = store.getters.getRouteData.requireAuth;

						store.commit(
							"setLoginStatus",
							false
						);

						if (requireAuth) {
							location.reload();
						}

					} else {
						store.commit(
							"setInfoUser",
							infoUser ? JSON.parse(infoUser) : null
						);
					}

					Init.startApp();

				}
			);

		} else {
			Init.startApp(true);
		}
	}

	static getUserInfo() {
		return api.post("auth/get-user");
	}

	static defineExtras() {
		Status();
	}

	static async startApp(pause = false) {

		events();

		if (pause) {
			await sleep(1200)
		}

		bus.$emit("app_started", true);

		await sleep(700);

		store.commit(
			"setAppStarted",
			true
		);

	}
}


export default Init;



// WEBPACK FOOTER //
// ./src/js/connection/init.js